<template>
    <div class="row">
        <div class="col-lg-12 text-center">
            <div style="border: none; border-radius: 10px;" class="panel panel-default country-select-panel">
                <div class="panel-body">
                    <h1>404</h1>
                    <br>
                    <h4>Requested page not found</h4>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    export default {
        name: 'server-error',
        data() {
            return {}
        },
        methods: {}
    }
</script>